module.exports = __webpack_public_path__ + "img/icon_23years_es.b87c3618.png";